const makeConstant = constant => `auth/${constant}`

export const REGENERATE_CODE = makeConstant('REGENERATE_CODE')
export const REGENERATE_CODE_SUCCESS = makeConstant('REGENERATE_CODE_SUCCESS')
export const REGENERATE_CODE_PENDING = makeConstant('REGENERATE_CODE_PENDING')
export const REGENERATE_CODE_FAILED = makeConstant('REGENERATE_CODE_FAILED')



// WEBPACK FOOTER //
// ./src/modules/auth/constants.js